import { render, staticRenderFns } from "./ParamMotivo.vue?vue&type=template&id=1297fd0b"
import script from "./ParamMotivo.vue?vue&type=script&lang=js"
export * from "./ParamMotivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports